import { MDBFooter } from 'mdb-vue-ui-kit';
import axios from "axios";
export default {
    name: 'AppFooter',
    components: {
        MDBFooter
    },
    data () {
        return {
            post: {}
        }
    },
    mounted() {
        axios
            .get(this.$config.VUE_APP_API_DOMAIN + "/pages/179")
            .then(async response => {
                this.post = response.data
            })
            .catch(error => {
                this.error = error.message;
                console.error("There was an error!", error);
            })
    }
};